import { createQueryParams } from '@/shared/lib/location';

import { BASE_URL } from '../constants';
import { del, get, patch, post } from '../requestMethods';
import {
  CreateGlossaryRequestData,
  Glossary,
  GlossaryRequestData,
  GlossaryWithEntries,
  UpdateGlossaryRequestData,
} from './types';

const GLOSSARY_URL = `${BASE_URL}/api/glossary/`;

export const GLOSSARY_API = {
  glossaryUpdate: ({ glossaryId, ...data }: UpdateGlossaryRequestData) =>
    patch<Glossary>(`${GLOSSARY_URL}${glossaryId}`, { data }),

  createGlossary: (data: CreateGlossaryRequestData) => post<Glossary>(GLOSSARY_URL, { data }),

  deleteGlossary: (glossaryId: string) =>
    del<{
      ok: boolean;
    }>(`${GLOSSARY_URL}?glossary_id=${glossaryId}`),

  getGlossaries: ({ dst_lang, space_id, src_lang }: GlossaryRequestData) =>
    get<Glossary[]>(
      `${GLOSSARY_URL}${createQueryParams({
        source_lang: src_lang,
        space_id,
        target_lang: dst_lang,
      })}`,
    ),

  getGlossary: (glossaryId: string) => get<GlossaryWithEntries>(`${GLOSSARY_URL}${glossaryId}`),
};
